import { createLocationIdLabel } from '@/features/advertisement/components/gpt/searchGpt'
import { type GptTargeting } from '@/features/advertisement/types/adConfig'

export const getLocationTargetingKeys = ({
  locationId,
}: {
  locationId: number
}): GptTargeting[] => {
  /** Location Keys */
  const locationKeys: GptTargeting[] = [createLocationIdLabel(locationId)]

  return locationKeys
}
